import React from 'react';

const Loading = ({ message = 'Loading...' }) => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-[#234a88] mb-4"></div>
        {message && <p className="text-gray-600 font-light text-sm">{message}</p>}
      </div>
    </div>
  );
};

export default Loading;
